import React from 'react';
import TextInput from './TextInput'
import LayerForAssetLoader from './ImageUploadInput'

const Editor = ({ onTextInputBlur, textElements, layersForAssets, textElementsLinesConfig, onTextInputFocus, onTextInputChange, handleAssetChange }) => (
  <div>
      <h3>Edit Text</h3>
      <div>
      {
        textElements &&
        textElements.map((element, index) =>
          <TextInput
            linesConfig={textElementsLinesConfig[index]}
            key={`te-${index}`}
            index={index}
            element={element}
            onTextInputFocus={onTextInputFocus}
            onChange={onTextInputChange}
            onTextInputBlur={onTextInputBlur}
          />
        )
      }
      </div>
    <hr />
    <div>
      <h3>Edit Graphics</h3>
      <div>
      {
        layersForAssets &&
        layersForAssets.map(({ layer, asset }, index) =>
          <LayerForAssetLoader
            key={`lfo-${index}`}
            layer={layer}
            asset={asset}
            onChange={(canvas, userInteraction) => handleAssetChange(layer, asset, canvas, userInteraction)}
          />
        )
      }
      </div>
    </div>
  </div>
)


export default Editor;



// WEBPACK FOOTER //
// ./src/components/Editor.js